// extracted by mini-css-extract-plugin
export default {"root":"TabPanels_root__cdghN"};